import { Component, OnInit } from '@angular/core';
import { Recipe } from '../Models/recipe';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth.service';
import { SearchService } from '../search.service';

@Component({
  selector: 'app-recipe',
  templateUrl: './recipe.component.html'
})
export class RecipeComponent implements OnInit {

  id: number;
  recipe: Recipe;

  constructor(
    public router: Router, 
    private route: ActivatedRoute,
    private httpClient: HttpClient,
    public authService: AuthService,
    public searchSvc: SearchService
  ) { 
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });
  }

  /**
   * 
   */
  ngOnInit() {
    this.httpClient.get(environment.apiUrl + '/get?id=' + this.id).subscribe((r: Recipe) => {
      this.recipe = r;

      this.recipe.Ingredients = this.recipe.Ingredients.replace(/\n/g, '<br/>');
      this.recipe.Directions = this.recipe.Directions.replace(/\n/g, '<br/>');
      this.recipe.Notes = this.recipe.Notes.replace(/\n/g, '<br/>');
    });
  }

  /**
   * 
   */
  editRecipe() {
    this.router.navigate(['/edit-recipe', this.id]);
  }
}
